import React, { FC } from "react";

export const HideOnPrint: FC = (props) => (
  <div className={"hide-on-print"}>{props.children}</div>
);
